import { 
  createLightTheme, 
  createDarkTheme, 
  BrandVariants, 
  Theme 
} from '@fluentui/react-components';

// QuickDial brand colors - maintaining existing purple/blue palette
const quickDialBrand: BrandVariants = {
  10: "#020305",
  20: "#111318", 
  30: "#16202D",
  40: "#1B2F47",
  50: "#203F62",
  60: "#25507C",
  70: "#2B6197",
  80: "#3174B2",
  90: "#3787CD",
  100: "#3E9BE8",
  110: "#46AFF0",
  120: "#62B9F2",
  130: "#7EC3F4",
  140: "#9ACDF6",
  150: "#B6D7F8",
  160: "#D2E1FA"
};

// Create light and dark themes
export const lightTheme: Theme = {
  ...createLightTheme(quickDialBrand),
};

export const darkTheme: Theme = {
  ...createDarkTheme(quickDialBrand),
};

// QuickDial specific brand tokens
export const quickDialTokens = {
  // Primary brand color (maintaining the existing purple)
  brandColorPrimary: '#872E8B',
  brandColorSecondary: '#2563eb',
  
  // Surface colors
  surfaceBackground: '#f5f5f5',
  surfaceCard: '#ffffff',
  
  // Text colors  
  textPrimary: '#323130',
  textSecondary: '#605e5c',
  
  // Interactive colors
  interactiveHover: '#f3f2f1',
  interactivePressed: '#edebe9',
  
  // Border radius
  borderRadius: {
    small: '4px',
    medium: '8px', 
    large: '12px',
    xLarge: '16px'
  },
  
  // Spacing
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  }
};
